'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of basket
 */ const Basket = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M54.1916 31.1563V28.4416C55.271 28.4416 56.1461 27.5666 56.1461 26.4872V25.8722C56.1461 24.4531 54.9957 23.3027 53.5766 23.3027H40.8041C39.3851 23.3027 38.2347 24.4531 38.2347 25.8722V26.4872C38.2347 27.5666 39.1097 28.4416 40.1892 28.4416V31.1964C39.1167 31.5881 38.1918 32.2926 37.5387 33.2155C36.8856 34.1384 36.5354 35.2355 36.5352 36.3595V52.3052C36.5352 54.3131 38.1629 55.9408 40.1708 55.9408H54.3281C56.336 55.9408 57.9637 54.3131 57.9637 52.3052V36.362C57.9637 35.2168 57.6004 34.1001 56.9244 33.1671C56.2483 32.2341 55.2931 31.5313 54.1916 31.1563Z",
                fill: theme.ds5.asset[assetColor].backItem
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M67.8667 36.643V34.3002C68.7982 34.3002 69.5534 33.545 69.5534 32.6134V32.0827C69.5534 30.858 68.5606 29.8652 67.3359 29.8652H56.3131C55.0884 29.8652 54.0956 30.858 54.0956 32.0827V32.6134C54.0956 33.545 54.8508 34.3002 55.7824 34.3002V36.6776C54.8568 37.0156 54.0586 37.6237 53.495 38.4201C52.9313 39.2166 52.6291 40.1633 52.6289 41.1334V54.3967C52.6289 56.4046 54.2566 58.0324 56.2646 58.0324H67.4864C69.4943 58.0324 71.1221 56.4046 71.1221 54.3967V41.1355C71.122 40.1472 70.8085 39.1835 70.2251 38.3783C69.6416 37.5731 68.8173 36.9666 67.8667 36.643Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "38.0664",
                y: "23.3027",
                width: "18.2036",
                height: "5.04806",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "53.8203",
                y: "29.8887",
                width: "15.909",
                height: "4.28321",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "26.5938",
                y: "49.3125",
                width: "53.7931",
                height: "8.66667",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.8008 55.6934L30.7841 82.5319C31.1036 83.9622 32.3705 84.9807 33.8339 84.9807H73.7446C75.2081 84.9807 76.4771 83.9622 76.7944 82.5319L82.7778 55.6934H24.8008Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M25.1883 45.123H82.6976C85.2176 45.123 87.2648 47.1434 87.2648 49.6302V53.7897H20.6211V49.6302C20.6211 47.1434 22.6683 45.123 25.1883 45.123Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.832 47.5172L78.901 26.8965",
                stroke: "#FCFAFF",
                strokeWidth: "3.05681",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M36.7545 47.5172L28.9844 26.8965",
                stroke: "#FCFAFF",
                strokeWidth: "3.05681",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35 62L38.935 79.3088H43.1335L40.7097 62H35Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M71.6194 62L67.6843 79.3088H63.4883L65.9096 62H71.6194Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M50.0938 62L51.229 79.3088H55.3843L56.5196 62H50.0938Z",
                fill: theme.ds5.asset[assetColor]["300"]
            })
        ]
    });
};

exports.Basket = Basket;
//# sourceMappingURL=Basket.cjs.map
